module.exports = __webpack_public_path__ + "static/media/shell01.0a628aab.jpg";